import { faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";

interface filterProps {
    onFilter : (cols : string[]) => void;
}

const ColumnFilters : React.FC<filterProps> = ({onFilter}) => {
        const defaultFilterCol = [
            { selected : true, columns: "Processed Date" },
            { selected : true, columns: "Client" },
            { selected : true, columns: "Position Title" },
            { selected : true, columns: "Career Level" },
            { selected : true, columns: "Status" },
            { selected : true, columns: "Start Date" },
            { selected : true, columns: "Revenue" }
        ]
        const savedColFilter = localStorage.getItem('column_filter');
        const parsedColFilter = savedColFilter ? JSON.parse(savedColFilter) : defaultFilterCol;
        const [showFilter, setShowFilter] = useState<boolean>(false);
        const [colArray, setColArray] = useState<{selected : boolean; columns: string }[]>(
            defaultFilterCol.length === parsedColFilter.length ? parsedColFilter : defaultFilterCol 
        );
        const divFloatCard = useRef<HTMLDivElement | null>(null);
    
        const handleSelectColumn = (column : string | null) => {
            if(column === null){
                const all_selected = colArray.every(item => item.selected === true);
                setColArray(colArray.map(col => ({...col, selected : all_selected ? false : true})));
            }else{
                setColArray(colArray.map(col =>  column === col.columns ? ({...col, selected : col.selected ? false : true}) : col));
            }
        }
    
        const handleClickOutside = (event: MouseEvent) => {
            if (
                !(divFloatCard.current?.contains(event.target as Node))
            ) {
                setShowFilter(false);
            }
        };
    
        useEffect(()=>{
            let columns : string[] = [];
            for(const obj of colArray ){
                if(obj.selected){
                    columns.push(obj.columns);
                }
            }
            onFilter(columns);
            localStorage.setItem('column_filter', JSON.stringify(colArray));
        // eslint-disable-next-line react-hooks/exhaustive-deps
        },[colArray])
    
        useEffect(() => {
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
              document.removeEventListener("mousedown", handleClickOutside);
            };
        }, []);

        return(
            <div className="relative">
                <div 
                    onClick={()=>setShowFilter(showFilter ? false : true)}
                    className="flex justify-center gap-2 text-md uppercase border px-2 py-1 shadow bg-gray-100 cursor-pointer hover:bg-gray-200">
                    <div>
                        <FontAwesomeIcon  icon={faSquareCheck} className="text-gray-500" />
                    </div>
                    <button>
                        Columns
                    </button>
                </div>
                {showFilter && (
                    <div ref={divFloatCard} className=" flex flex-col gap-2 absolute top-12 end-8 bg-white border p-2 z-50 shadow-lg max-h-[46rem] overflow-y-auto min-w-44">
                        <div className="flex gap-2 items-center ms-4">
                            <div>
                                <input type="checkbox" onChange={()=>handleSelectColumn(null)} checked={colArray.every(item => item.selected === true)} className="cursor-pointer" />
                            </div>
                            <div>
                                <h2>Select All</h2>
                            </div>
                        </div>
                        {colArray.map(col => (
                            <div className="flex gap-2 items-center ms-4">
                                <div>
                                    <input type="checkbox" onChange={()=>handleSelectColumn(col.columns)} checked={col.selected} className="cursor-pointer" />
                                </div>
                                <div>
                                    <h2>{col.columns}</h2>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
}

export default ColumnFilters;